import React, { useState } from 'react';
import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ChildHeader from '../../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../../components/common/FilterBy';
import { SearchBar } from '../../../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../../../components/common';
import useDebounce from '../../../../hooks/useDebounce';
import { ViewIconButton } from '../../../../components/common/button/CustomIconButton';
import { useQuery } from '../../../../hooks/UseQuery';
import { constants } from '../constant';

const tableHeaderObj = [
  [
    { text: 'S.NO.', rowspan: 1, colspan: 1 },
    { text: 'SUPPLIER NAME', rowspan: 1, colspan: 1 },
    { text: 'SUPPLIER CODE', rowspan: 1, colspan: 1 },
    { text: 'Address', rowspan: 1, colspan: 1 },
    { text: 'GST / UIN', rowspan: 1, colspan: 1 },
    { text: 'State Name', rowspan: 1, colspan: 1 },
    { text: 'ACTION', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [{ value: 'createdAt', name: 'A-Z' }];

const SelectSupplier = () => {
  const [data, setData] = useState<any[]>([]);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const navigate = useNavigate();

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/vendorRoute/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  useDebounce(fetchData, 500, [page, search, filter]);

  return (
    <Box sx={{ width: '80vw' }}>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy label="SORT" options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.vender_name}</TableCell>
                  <TableCell align="center">{item?.vender_code}</TableCell>
                  <TableCell align="center">{item?.address}</TableCell>
                  <TableCell align="center">{item?.gst_no}</TableCell>
                  <TableCell align="center">{item?.state}</TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <ViewIconButton
                        tooltipTitle="VIEW"
                        onClick={() => {
                          navigate(
                            `${constants.navigate.view}/${item._id}?supplier_name=${item?.vender_name}&address=${item?.address}&gst=${item?.gst_no}&state=${item?.state}`
                          );
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
    </Box>
  );
};

export default SelectSupplier;
